import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import './styles/PendingConfirmationsCard.css';
import './board/OverviewBoard.css';

const PendingMeetingsCard = ({ pendingMeetings, onViewAll, onMeetingClick }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/meetings/list', { state: { initialTab: 2 } });
  };

  return (
    <div className="pending-confirmations-container overview-board">
      <OverviewBoardHeader
        eyebrow="Pending"
        title="Meetings"
        count={`${pendingMeetings.length} waiting`}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all pending meetings"
      />

      <div className="pending-confirmations-content">
        {pendingMeetings.length > 0 ? (
          <ul className="pending-confirmations-list">
            {pendingMeetings.slice(0, 4).map((meeting, index) => (
              <li
                key={meeting.id || index}
                className="pending-confirmations-item"
                onClick={() => onMeetingClick && onMeetingClick(meeting)}
              >
                <div className="pending-appointment-content">
                  <div className="pending-appointment-header">
                    <h4 className="pending-appointment-client-name">
                      {meeting.title || 'Meeting'}
                    </h4>
                    <span className="appointment-status pending">pending</span>
                  </div>
                  <div className="pending-appointment-details">
                    <p className="pending-appointment-service">
                      {meeting.clientName ? `With ${meeting.clientName}` : 'Meeting'}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="pending-confirmations-empty">
            <p>No pending meetings</p>
          </div>
        )}
      </div>

      {pendingMeetings.length > 4 && (
        <div className="pending-confirmations-footer">
          <p onClick={handleViewAll}>
            {pendingMeetings.length - 4} more pending meetings
          </p>
        </div>
      )}
    </div>
  );
};

export default PendingMeetingsCard;
